import { productEnabled } from '@get-bridge/learn-legacy-shared/dist/utils/accountConfig';

export default {
  oneOnOneAgendas: hosts => hosts.perform && productEnabled('perform') && {
    id: 'SECONDARY_TEAM_1ON1_AGENDAS',
    host: hosts.perform,
    href: '/talent/career/1on1',
    name: I18n.t('1on1 Agendas'),
  },
  groupAgendas: hosts => hosts.perform && productEnabled('perform') && {
    id: 'SECONDARY_TEAM_GROUP_AGENDAS',
    host: hosts.perform,
    href: '/talent/group-agendas',
    name: I18n.t('Group Agendas'),
  },
  goals: (hosts, user) => hosts.perform && productEnabled('perform') && user.isManager && {
    id: 'SECONDARY_TEAM_GOALS',
    host: hosts.perform,
    href: `/talent/team/${user.id}/goals`,
    otherHrefs: [
      `/talent/goals/${user.id}/assign`,
    ],
    name: I18n.t('Goals'),
    okrName: I18n.t('Objectives'),
  },
  skills: (hosts, user) => hosts.perform && productEnabled('perform') && user.isManager && {
    id: 'SECONDARY_TEAM_SKILLS',
    host: hosts.perform,
    href: `/talent/team/${user.id}/assessment/peers`,
    name: I18n.t('Skills'),
  },
  engagementSurveys: (hosts, user) => hosts.perform && productEnabled('engage') && user.isManager && {
    id: 'SECONDARY_TEAM_ENGAGEMENT_SURVEYS',
    host: hosts.perform,
    href: '/engage/manager',
    name: I18n.t('Engagement Surveys')
  },
};



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/utils/buildAtlasLinks/primaryLinks/team.js